// extracted by mini-css-extract-plugin
export var billingAddress = "_rr-g";
export var contactInfo = "_rr-d";
export var customerInfoContainer = "_rr-c";
export var customerInfoContainerMobile = "_rr-h";
export var customerInfoRow = "_rr-a";
export var customerInfoSection = "_rr-b";
export var fullWidthDividerMobile = "_rr-i";
export var imageContainer = "_rr-1";
export var paymentMethod = "_rr-e";
export var priceText = "_rr-6";
export var priceTextMobile = "_rr-7";
export var product = "_rr-0";
export var productImage = "_rr-2";
export var productInfo = "_rr-4";
export var productMobile = "_rr-9";
export var productTitle = "_rr-8";
export var quantityBadge = "_rr-3";
export var quantityText = "_rr-5";
export var shippingAddress = "_rr-f";